import React from 'react';
import { IoGridOutline, IoBusinessOutline } from 'react-icons/io5';
import { NavLink } from 'react-router-dom';
import './index.css';
import logo from '../../../assets/logo/next2estate-black.png';

function SideBar({ sidenavCollapsed, setSidenavCollapsed }) {

  const handleSidenav = () => {
    setSidenavCollapsed(!sidenavCollapsed);
  }

  return (
    <div className='sidebar'>
      <div className='sidebar-head'>
        <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'sidebar-logo'}>
          <img src={logo} alt="next2estate-logo" />
          <div className='brand-name'>
            R-ES PROVIDER
          </div>
        </div>
      </div>
      <ul>
        <li>
          <NavLink to="/admin/dashboard" >
            <div className='link-icon'><IoGridOutline color={`var(--primary)`} size={19} /></div>
            <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Dashboard</div>
          </NavLink>
        </li>
        <li className='border-top'>
          <NavLink to="/admin/businesses">
            <div className='link-icon'><IoBusinessOutline color={`var(--bs-success)`} size={20} /></div>
            <div className={sidenavCollapsed ? 'collapsed-side-hide' : 'link-label'}>Businesses</div>
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default SideBar;
